module.exports = __webpack_public_path__ + "static/media/capitalsphere_context.bca83b20.png";